import React from 'react';
import SiteNav from '../../components/site/SiteNav';
import SiteFooter from '../../components/site/SiteFooter';
import { Share2, Terminal, Shield, Zap, RefreshCw, Cpu } from 'lucide-react';

const Integrations = () => {
    const integrations = [

        {
            name: "Iyzico",
            desc: "Online ödemeleriniz için güvenli altyapı. Kredi kartı ile hızlı bakiye yükleme.",
            icon: Shield
        },
        {
            name: "Restoran Otomasyonları",
            desc: "Mevcut adisyon sisteminizle entegre çalışarak verileri eşzamanlı aktarır.",
            icon: RefreshCw
        },
        {
            name: "API & Webhook",
            desc: "Kendi yazılımlarınızı Ugra altyapısına bağlayın. Esnek ve güçlü API desteği.",
            icon: Terminal
        }
    ];

    return (
        <div style={{ background: 'var(--bg-main)', minHeight: '100vh' }}>
            <SiteNav />
            <section style={{
                padding: '16rem 10% 6rem',
                background: 'linear-gradient(180deg, rgba(var(--primary-rgb), 0.08) 0%, transparent 100%)',
                textAlign: 'center',
                position: 'relative'
            }}>
                <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 24px',
                    background: 'rgba(var(--primary-rgb), 0.1)',
                    color: 'var(--primary)',
                    borderRadius: '99px',
                    fontSize: '0.875rem',
                    fontWeight: 800,
                    marginBottom: '2.5rem',
                    border: '1px solid rgba(var(--primary-rgb), 0.2)',
                    textTransform: 'uppercase',
                    letterSpacing: '2px'
                }}>
                    <Share2 size={16} /> <span>Ekosistem</span>
                </div>
                <h1 style={{ fontSize: 'clamp(3rem, 7vw, 5.5rem)', fontWeight: 900, marginBottom: '2rem', letterSpacing: '-0.04em', lineHeight: 1 }}>
                    Güçlü Entegrasyon <br />
                    <span className="text-gradient">Ekosistemi</span>
                </h1>
                <p style={{ fontSize: '1.25rem', color: 'var(--text-muted)', maxWidth: '800px', margin: '0 auto', lineHeight: 1.6 }}>
                    Ugra, kullandığınız donanım ve yazılımlarla konuşur. Veri girişini manuel yapmanıza gerek kalmaz.
                </p>
            </section>

            <section style={{ padding: '0 10% 10rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                {integrations.map((item, idx) => (
                    <div key={idx} className="card glass interactive" style={{ padding: '2.5rem', position: 'relative' }}>

                        <div style={{ background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)', padding: '12px', borderRadius: '12px', width: 'fit-content', marginBottom: '1.5rem' }}>
                            <item.icon size={32} />
                        </div>
                        <h3 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '1rem' }}>{item.name}</h3>
                        <p style={{ color: 'var(--text-muted)', lineHeight: '1.6' }}>{item.desc}</p>
                    </div>
                ))}
            </section>

            <section style={{ padding: '8rem 10%', background: '#111', color: 'white', textAlign: 'center' }}>
                <Cpu size={48} style={{ color: 'var(--primary)', marginBottom: '2rem' }} />
                <h2 style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: '2rem' }}>Geliştiriciler İçin Ugra API</h2>
                <p style={{ fontSize: '1.125rem', color: '#aaa', maxWidth: '600px', margin: '0 auto 3rem' }}>
                    Kendi uygulamanızı Ugra'ya bağlamanız için dokümantasyonumuz hazır. Gerçek zamanlı etkileşimler ve kullanıcı verileri parmaklarınızın ucunda.
                </p>
                <button className="btn-primary" style={{ padding: '1rem 2.5rem', borderRadius: '12px' }}>Dokümantasyona Göz At</button>
            </section>

            <SiteFooter />
            <style>{`
                .text-gradient {
                    background: linear-gradient(135deg, var(--primary) 0%, #d97706 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .interactive { transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1); cursor: default; }
                .interactive:hover { transform: translateY(-10px); border-color: var(--primary); box-shadow: 0 30px 60px -20px rgba(var(--primary-rgb), 0.15); }
                @media (max-width: 1024px) {
                    section { padding: 8rem 5% !important; }
                    h1 { font-size: 2.5rem !important; }
                }
            `}</style>
        </div>
    );
};

export default Integrations;
